var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoForMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.01172C6 1.18311 6.67163 0.511719 7.5 0.511719H10.5C11.3284 0.511719 12 1.18311 12 2.01172V5.01172C12 5.84033 12.6716 6.51172 13.5 6.51172H19.5C20.3284 6.51172 21 7.18311 21 8.01172V11.0117C21 11.8403 20.3284 12.5117 19.5 12.5117H13.5C12.6716 12.5117 12 13.1831 12 14.0117V17.0117C12 17.8403 12.6714 18.5117 13.5 18.5117H16.5C17.3284 18.5117 18 19.1831 18 20.0117V23.0117C18 23.8403 17.3284 24.5117 16.5 24.5117H13.5C12.6716 24.5117 12 23.8403 12 23.0117V20.0117C12 19.1836 11.3286 18.5117 10.5 18.5117H7.5C6.67163 18.5117 6 17.8403 6 17.0117V15.5117C6 14.6831 5.32837 14.0117 4.5 14.0117H1.5C0.671631 14.0117 0 13.3403 0 12.5117V9.51172C0 8.68311 0.671631 8.01172 1.5 8.01172H4.5C5.32837 8.01172 6 7.34033 6 6.51172V5.01172V2.01172Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForMobile);
export default __webpack_public_path__ + "static/media/logoForMobile.2e3ba8946c01529c191a44acaa1d60f2.svg";
export { ForwardRef as ReactComponent };